var map = {
	"./GEDA.png": 557,
	"./android-2.jpg": 454,
	"./android-wallpaper.jpg": 73,
	"./clean-code-book.png": 469,
	"./convolutional-neural-networks.jpeg": 128,
	"./dogger.jpg": 552,
	"./google-cloud.jpg": 981,
	"./journal.jpg": 139,
	"./kemaro-k900.png": 274,
	"./mac-essentials.jpg": 293,
	"./matrix-multiplication-1.png": 615,
	"./matrix-multiplication.png": 20,
	"./nextjs-gallery.jpg": 891,
	"./rock-paper-scissors.jpeg": 841,
	"./rock-paper-scissors.png": 804,
	"./train-delay-visualizer.png": 729
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 670;